
import { ChipType } from '@internal/plugin-components-react';


export const getChipType = (acPermissionAction) => {
  let chipType;
  switch (acPermissionAction) {
    case 'read':
      chipType = ChipType.lightBlue;
      break;
    case 'create':
      chipType = ChipType.lightYellow;
      break;
    case 'update':
      chipType = ChipType.lightGreen;
      break;
    default:
      chipType = ChipType.tag;
  }

  return chipType;
};

export const moduleOptions = [
  {
    label: 'Cluster',
    value: 'cluster',
  },
  {
    label: 'Cluster Page',
    value: 'cluster-page',
  },
  {
    label: 'Metric',
    value: 'metric',
  },
  {
    label: 'Component',
    value: 'component',
  },
  {
    label: 'Catalog Import Page',
    value: 'catalog-import-page',
  },
  {
    label: 'BlackBox Page',
    value: 'blackbox-page',
  },
  {
    label: 'Access Control Page',
    value: 'access-control-page',
  },
];
